import type { ReactNode } from "react";
import { AppTopBar } from "../AppTopBar";

function FugroLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 32"
      width={20}
      height={32}
      fill="none"
      role="img"
      aria-label="Fugro"
    >
      <path
        fill="var(--foreground)"
        d="M9.63455 0.000922566C9.27842 0.0328712 8.94525 0.212604 8.69895 0.505681C8.45266 0.798759 8.31058 1.18457 8.29998 1.589V5.15241H0.476074V7.20432H8.31166V27.9604L10.4086 32L12.5172 27.9604V7.20432H19.5237V5.15045H12.4922V3.27995C12.4982 3.14176 12.5494 3.01104 12.6357 2.91312C12.722 2.8152 12.8373 2.75714 12.9593 2.75005H19.422V0H9.70544"
      />
    </svg>
  );
}

type AppLayoutProps = {
  nav: ReactNode;
  navBottom?: ReactNode;
  children: ReactNode;
};

export function AppLayout({ nav, navBottom, children }: AppLayoutProps) {
  return (
    <div>
      <div className="fixed right-0 bottom-0 left-nav-rail-width-collapsed top-app-bar-height overflow-auto">
        {children}
      </div>
      <div className="flex flex-row fixed top-0 left-nav-rail-width-collapsed right-0 h-app-bar-height">
        <AppTopBar />
      </div>
      <div className="flex flex-col fixed top-0 left-0 bottom-0 w-nav-rail-width-collapsed">
        <nav className="relative inline-flex grow flex-col items-center gap-layout-medium px-layout-xxsmall py-layout-xsmall w-full bg-popover shadow-raised hover:border-r hover:border-r-primary">
          <div className="flex size-[48px] items-center justify-center">
            <FugroLogo />
          </div>
          <div className="flex flex-col items-start gap-component-xsmall flex-[1_0_0] self-stretch">{nav}</div>
          {navBottom && <div className="flex flex-col items-start gap-component-xsmall self-stretch">{navBottom}</div>}
        </nav>
      </div>
    </div>
  );
}
